import * as React from "react";

function ChartUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M160 320c53.02 0 96-42.98 96-96s-42.98-96-96-96c-53.9 0-96 42.1-96 96 0 53 42.1 96 96 96zm0-144c26.47 0 48 21.53 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm32 176h-64C57.31 352 0 409.3 0 480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32 0-70.7-57.3-128-128-128zM49.61 464c7.43-36.5 39.76-64 78.39-64h64c38.63 0 70.96 27.53 78.39 64H49.61zM584 0H216c-30.9 0-56 25.12-56 56v24c0 13.25 10.75 24 24 24s24-10.75 24-24V56c0-4.406 3.594-8 8-8h368c4.406 0 8 3.594 8 8v304c0 4.406-3.594 8-8 8H352c-13.25 0-24 10.75-24 24s10.8 24 24 24h232c30.88 0 56-25.12 56-56V56c0-30.88-25.1-56-56-56zM328.1 167c-9.375-9.375-24.6-9.375-33.98 0s-9.354 24.58.02 33.96l71.98 72.02C371.7 277.7 377.8 280 384 280s12.3-2.323 16.99-7.01L496 177.9V200c0 13.3 10.8 24 24 24s24-10.7 24-24v-80c0-13.2-10.7-24-24-24h-80c-13.2 0-24 10.8-24 24s10.75 24 24 24h22.06L384 222l-55.9-55z"
  }));
}

const ForwardRef = React.forwardRef(ChartUserIcon);
export default ForwardRef;